import React from "react";

import RulesSvg from "../../assets/images/icons/tasks/green.svg";

export const RulesGreenIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={RulesSvg}
        alt={alt || "Rules"}
    />
);
